export enum SceneMode {
  Edit = 'edit',
  Normal = 'normal'
}
